import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: 24,
        width: '100%',
        '& .MuiFormControl-root': {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '11px',
        },
        '& .MuiFormControl-root a': {
            textDecoration: 'none',
        },
        '& .MuiFormControlLabel-root': {
            fontSize: '14px !important',
            marginLeft: 0,
        },
        '& .MuiFormControlLabel-label': {
            color: '#565C64',
            lineHeight: '16px',
            fontSize: '14px',
        },
        '& .MuiFormControlLabel-label a': {
            color: '#1094f7',
            textDecoration: 'none',
        },
        '& .MuiFormControlLabel-label a:hover': {
            color: '#0E79C9',
        },
        '& .MuiAutocomplete-root .MuiFormControl-root': {
            marginBottom: '0 !important',
        },
        '& .MuiFormHelperText-contained': {
            marginLeft: '0 !important',
        },
        '& .MuiInputLabel-formControl': {
            top: '1px',
        },
        [theme.breakpoints.down('xs')]: {
            marginBottom: 0,
        },
    },
    '@global': {
        '*': {
            scrollbarWidth: 'thin',
            scrollbarColor: '#E6E6E6 transparent',
        },
        '*::-webkit-scrollbar': {
            height: 6,
            width: 6,
        },
        '*::-webkit-scrollbar-track': {
            background: 'rgba(0, 66, 105, 0.06)',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#E6E6E6',
            borderRadius: 4,
        },
    },
}));

export function Form(props) {
    const classes = useStyles();

    return <form className={classes.root}>{props.children}</form>;
}
